import api from "./index";
import { UserFilterDefaultsUpdate, UserFilterDefaults } from "../models/usersFilters";
const BASE = '/userfilters';

export const updateUserFilterByEmail = async (
    updates: UserFilterDefaultsUpdate
): Promise<UserFilterDefaults> => {
    try {
        const response = await api.patch(`${BASE}/update`, updates);
        return response.data as UserFilterDefaults;
    } catch (error) {
        console.error("Failed to update user filters:", error);
        throw error;
    }
};


export const getUserFilterByEmail = async (email: string) => {
    try {
        const response = await api.get(`${BASE}/get/${email}`);
        return response.data as UserFilterDefaults;
    } catch (error) {
        console.error('Failed to fetch filters:', error);
        throw error;
    }
};

